module.exports = __webpack_public_path__ + "img/pages.72ea9271.svg";